import FormSelect from "components/Common/Form/Select";
import { useSearchParams } from "react-router-dom";
import { useProductFlags } from "src/hooks/recoil/useProductFlags";
import { useRouter } from "src/hooks/useRouter";
import styles from "./SiteTypeOptions.module.scss";
import { useFormContext } from "react-hook-form";
import { useProductOptions } from "src/mocks/useProductOptions";
import { useTranslation } from "react-i18next";

interface ISiteTypeOptionsProps {
  productKey: string;
  priceType?: string;
  isRenew?: boolean;
  // handleChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
}
const SiteTypeOptions = ({
  productKey,
  priceType = "premium",
  isRenew = false,
}: // handleChange,
ISiteTypeOptionsProps) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const route = useRouter();
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const { isOciProduct } = useProductFlags();
  const { t } = useTranslation();
  const { options, currentValue, isSelectDisabled, showAsText } =
    useProductOptions({
      productKey,
      priceType,
      isRenew,
      currentPath: location.pathname,
    });
  return (
    <>
      <div className={styles.siteTypeOptionsTitle}>
        {priceType && priceType !== ""
          ? t("siteType." + priceType + ".orderSpecification.title")
          : ""}
      </div>
      <div className="form-item">
        {/* <span className="form-item-title">
          {priceType && priceType !== ""
            ? t(
                "siteType." + priceType + ".orderSpecification.planType"
              )
            : ""}
        </span> */}
        {isOciProduct &&
        !searchParams.has("pay") &&
        !searchParams.has("type") ? (
          <span style={{ fontSize: "1rem" }}>
            {t(
              "siteType.subscriptionType." +
                productKey +
                ".subscriptionType_premium"
            )}
          </span>
        ) : (
          <FormSelect
            name="planType"
            label={t("siteManagement.paymentHistory.history.paymentSystem")}
            control={control}
            errors={errors}
            options={options}
            placeholder={t("subscriptionType.subTitle")}
            disabled={!isOciProduct}
            defaultValue={currentValue}
            // required
          />
        )}
      </div>
    </>
  );
};
export default SiteTypeOptions;
